<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="burgers" />
      </div>

      <div class="left" style="margin:-13px 0 0 27px;">
        <img src="/assets/images/titles/menu_left_burgers.png" />
      </div>

      <br clear="all">

      <div class="left" style="margin:-10px 0 0 25px;">
        <img src="/assets/images/Menu_burgers_womensleeping.png" />
      </div>

    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="left" style="width:522px; height:117px;">
        <img src="/assets/images/menu_img/menu_top_burger.png">
      </div>
      <br clear="all">

      <div class="menu_right">
        <div class="menu_name" style="margin-bottom:-5px;">
          <img src="/assets/images/menu_img/menu_burgers_customize.png">
        </div>

        <div class="menu_name">
          Patties
        </div>

        <div class="menu_option">
          <ul>
            <li>
              Hamburger <br/>
              <span>(USDA Choice Angus Beef-ground daily at Jeffrey&#8217;s)</span>
            </li>

            <li>Turkey burger &nbsp;</li>

            <li>Garden burger &nbsp;</li>
          </ul>
        </div>

        <div class="menu_name">
          TOASTED BUNS
        </div>

        <div class="menu_option">
          <ul>
            <li>classic white</li>
            <li>whole wheat</li>
          </ul>
        </div>

        <div class="menu_name">
          CHEESE
        </div>

        <div class="menu_option">
          <ul>
            <li>American, Swiss, Cheddar, Blue,  Jack &amp; Pepper Jack</li>
          </ul>
        </div>

        <div class="menu_name">
          TOPPINGS
        </div>

        <div class="menu_option">
          <ul>
            <li>lettuce, tomato, onion, mayo, mustard</li>
          </ul>
        </div>

        <div class="menu_name">
          EXTRAS
        </div>

        <div class="menu_option">
          <ul>
            <li>Cheese</li>

            <li>Honey Cured Bacon</li>

            <li>Saut&eacute;ed Mushrooms</li>

            <li>Fresh Avacado</li>

            <li>Grilled Onion</li>
          </ul>
        </div>
      </div>

      <div class="product-container">
        <ProductList :products="products" />
      </div>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'Burgers',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'HAMBURGER',
          description: 'Cooked just the way you like it',
        },
        {
          id: 2,
          name: 'CHEESEBURGER',
          description: 'Traditionally served with American. Upon request: cheddar, jack, pepper jack, swiss or blue',
        },
        {
          id: 3,
          name: 'BACON BURGER',
          description: 'Hardwood smoked, honey-cured bacon',
        },
        {
          id: 4,
          name: 'BACON CHEESEBURGER',
          description: 'America’s favorite combo',
        },
        {
          id: 5,
          name: 'MUSHROOM BURGER',
          description: 'Smothered with mushrooms sautéed with fresh garlic and soy sauce',
        },
        {
          id: 6,
          name: 'PINEAPPLE TERIYAKI BURGER',
          description: 'Cooked in teriyaki sauce & topped with a grilled slice of pineapple',
        },
        {
          id: 7,
          name: 'AVOCADO BURGER',
          description: 'Topped with Fresh Avocado Slices',
        },
        {
          id: 8,
          name: 'PATTY MELT',
          description: 'Served on light rye bread with melted swiss cheese and grilled onions',
        },
        {
          id: 9,
          name: 'DOUBLE CHEESEBURGER',
          description: 'Two patties & double cheese',
        },
      ],
    };
  },
};
</script>
